import { render, staticRenderFns } from "./KeypalBuy.vue?vue&type=template&id=85ca1646&scoped=true"
import script from "./KeypalBuy.vue?vue&type=script&lang=js"
export * from "./KeypalBuy.vue?vue&type=script&lang=js"
import style0 from "./KeypalBuy.vue?vue&type=style&index=0&id=85ca1646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ca1646",
  null
  
)

export default component.exports